module.exports = __webpack_public_path__ + "static/media/copyright.6dc38cfd.svg";